<template>
	<quote-modal 
	  :tray-image-url="trayImageUrl" 
	  :tray-name="selectedTrayName" 
	  :tray-size="selectedTraySize" 
	  :product-code="productCode" 
	  v-if="showQuoteModal" 
	  @close="showQuoteModal = false">
	</quote-modal>
	<email-modal :tray-image-url="trayImageUrl" v-if="showEmailModal" @close="showEmailModal = false"></email-modal>
	<div class="personal decor">
		<div class="header">
			<a href="https://cambro.com/traydesigner/rectangular-trays" class="left-arrow" target="_parent">
				<img src="images/left.svg" />
			</a>
			<h1>Décor Series Camtrays&reg;</h1>
		</div>
		<div class="personal-left" ref="trayContainer">
			<div class="tray-note">
				Décor Series Camtrays can be personalized in several ways.
				<ol>
					<li>Front of tray only.</li>
					<li>Back of tray only.</li>
					<li>Front and Back with the same design.</li>
					<li>Front and Back with a separate design on each side.</li>
				</ol>
			</div>
			<div id="tray-container-front">
				<div class="edge-white"></div>
				<div class="edge-black"></div>
				<transition name="fade" mode="out-in">
					<img :src="selectedTrayImage" :key="selectedTrayImage" width="100%" />
				</transition>
				<div v-if="uploadedImage" class="uploaded-image-front">
					<img :src="uploadedImage" alt="Uploaded Image" ref="targetElement" />
				</div>
				<moveable
					:target="targetElement"
					:draggable="true"
					:resizable="{ keepRatio: true }"
					:scalable="true"
					:rotatable="true"
					@drag="handleDragFront"
					@resize="handleResize"
					@scale="handleScale"
					@rotate="handleRotate"
				/>
                <div class="tray-front">Front</div>
			</div>
			<div id="tray-container-back">
				<div class="edge-white-back"></div>
				<div class="edge-black-back"></div>
				<transition name="fade" mode="out-in">
					<img :src="selectedTrayImage" :key="selectedTrayImage" width="100%" />
				</transition>
				<div v-if="uploadedImageBack" class="uploaded-image-back">
					<img :src="uploadedImageBack" alt="Uploaded Image" ref="targetElementBack" />
				</div>
				<moveable
					:target="targetElementBack"
					:draggable="true"
					:resizable="{ keepRatio: true }"
					:scalable="true"
					:rotatable="true"
					@drag="handleDragBack"
					@resize="handleResize"
					@scale="handleScale"
					@rotate="handleRotate"
				/>
                <div class="tray-back">Back</div>
			</div>
            <div class="coach">Click uploaded image to move it. Hold and drag corners to resize.</div>
		</div>
		<div class="personal-right">
			<h4>Select a Color</h4> <h5>{{ selectedTrayName }}</h5>
			<div class="select-color">
				<a href="javascript:void(0)" class="CharcoalGray815 active" @click="setActive($event, 'CharcoalGray815')"></a>
				<a href="javascript:void(0)" class="LightOak830" @click="setActive($event, 'LightOak830')"></a>
				<a href="javascript:void(0)" class="LightOlive820" @click="setActive($event, 'LightOlive820')"></a>
				<a href="javascript:void(0)" class="StonewashGray810" @click="setActive($event, 'StonewashGray810')"></a>
				<a href="javascript:void(0)" class="DarkOak825" @click="setActive($event, 'DarkOak825')"></a>
			</div>

			<h4>Add a Front Photo</h4>
			<input type="file" @change="onFileChange" ref="fileInput" />
            <button @click="resetUploadFront" class="btn-reset">Remove Image</button>
            <h4>Add a Back Photo</h4>
			<input type="file" @change="onFileChangeBack" ref="fileInputBack" />
  			<button @click="resetUploadBack" class="btn-reset">Remove Image</button>
			<div class="cleaner"></div>

			<h4>Select a Size</h4>
			<div class="select-size">
				<select name="size" id="select-dropdown" v-model="selectedSizeCode" @change="selectSize">
					<option value="1216DC">12" x 16" (30,5 x 41,5 cm)</option>
					<option value="1216DCET">12" x 16" (30,5 x 41,5 cm) EpicTread</option>
                    <option value="1418DC">14" x 18" (35,5 x 45,7 cm)</option>
					<option value="1418DCET">14" x 18" (35,5 x 45,7 cm) EpicTread</option>
                    <option value="1520DC">15" x 20" (38 x 51,5 cm)</option>
					<option value="1520DCET">15" x 20" (38 x 51,5 cm) EpicTread</option>
				</select>
			</div>
			<div>
				<h4>Your Tray Details</h4>
				<h5>Color: <strong>{{ selectedTrayName }}</strong></h5>
				<h5>Tray Size: <strong>{{ selectedTraySize }}</strong></h5>
				<h5>Product Code: <strong>{{ productCode }}</strong></h5>
			</div>
			<button @click="captureScreenshot(false)" class="btn-quote">Request a Free Sample and Quote</button>
			<button @click="downloadImage" class="btn-download">Download</button>
			<button @click="captureScreenshot(true)" class="btn-email">Email My Tray</button>

		</div>
	</div>
</template>
  
<script>
  import * as htmlToImage from 'html-to-image';
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
  import QuoteModal from './Quote.vue';
  import EmailModal from './EmailForm.vue';
  import { ref, onMounted, onUnmounted } from 'vue';
  import Moveable from "vue3-moveable";
  import '../assets/rectangle.css';
  export default {
	components: {
		QuoteModal,
		EmailModal,
		Moveable
	},
	setup() {
		const targetElement = ref(null);
        const targetElementBack = ref(null);
		const isMoveableActive = ref(false);
		const handleDragFront = ({ beforeTranslate }) => {
		targetElement.value.style.transform =
			`translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
		};
        const handleDragBack = ({ beforeTranslate }) => {
		targetElementBack.value.style.transform =
			`translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
		};
		const handleResize = ({ target, width, height, delta }) => {
			const aspectRatio = target.offsetWidth / target.offsetHeight;
			let newWidth = width;
			let newHeight = height;
			target.style.width = `${newWidth}px`;
    		target.style.height = `${newHeight}px`;
		};
		const handleScale = ({ target, dist }) => {
			const scaleX = dist[0];
			const scaleY = dist[1];
			target.style.transform = `scale(${scaleX}, ${scaleY})`;
		};
		const handleRotateFront = ({ beforeRotate }) => {
		targetElement.value.style.transform = `rotate(${beforeRotate}deg)`;
		};
        const handleRotateBack = ({ beforeRotate }) => {
		targetElementBack.value.style.transform = `rotate(${beforeRotate}deg)`;
		};

    return {
		targetElement,
        targetElementBack,
		handleDragFront,
        handleDragBack,
		handleResize,
		handleScale,
		handleRotateFront,
        handleRotateBack,
		isMoveableActive,
    };
  },
	data() {
	  return {
		showQuoteModal: false,
      	showEmailModal: false,
			emailFormData: {
			recipientEmail: '',
			message: '',
		},
		selectedTrayImage: 'images/rectangle/epictread/Charcoal-Gray-815.png',
		selectedColor: 'CharcoalGray815',
		selectedTrayName: 'Charcoal Gray',
		selectedTrayCode: '1216DC815',
    	selectedTraySize: '12" x 16" (30,5 x 41,5 cm)',
		selectedSizeCode: '1216DC',
		uploadedImage: null,
		uploadedImageBack: null,
		colorToImageMap: {
			CharcoalGray815: 'images/rectangle/epictread/Charcoal-Gray-815.png',
			LightOak830: 'images/rectangle/epictread/Light-Oak-830.png',
			LightOlive820: 'images/rectangle/epictread/Light-Olive-820.png',
			StonewashGray810: 'images/rectangle/epictread/Stonewash-Gray-810.png',
			DarkOak825: 'images/rectangle/epictread/Dark-Oak-825.png',
		}
	  };
	},
	methods: {
		print(val) {
			console.log(val)
		},
		captureScreenshot() {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
			filter: function (node) {
				return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach') && !node.classList.contains('tray-note');
				}
			})
			.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				this.showModal = true;
				})
			.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
			this.showEmailModal = true;
		},
		captureScreenshot(openEmailModal = false) {
		const node = this.$refs.trayContainer;
		htmlToImage.toPng(node, {
			filter: function (node) {
                return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach') && !node.classList.contains('tray-note');
				}
			})
			.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				if (openEmailModal) {
					this.showEmailModal = true;
					this.showQuoteModal = false;
				} else {
					this.showQuoteModal = true;
					this.showEmailModal = false;
				}
			})
			.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
		},
	resetUploadFront() {
		this.uploadedImage = null;
		this.$refs.fileInput.value = '';
	},
	resetUploadBack() {
		this.uploadedImageBack = null;
		this.$refs.fileInput.value = '';
	},
    setActive(event, color) {
		this.selectedColor = color;
		this.selectedTrayImage = this.colorToImageMap[color];
		this.selectedTrayName = this.formatTrayName(color); // Call the method here
		const swatches = document.querySelectorAll('.select-color a');
		swatches.forEach(sw => sw.classList.remove('active'));
		event.currentTarget.classList.add('active');
	},
    selectColor(color) {
      this.selectedTrayImage = this.colorToImageMap[color];
      this.selectedTrayName = this.formatTrayName(colorCode);
    },
    onFileChange(e) {
      const files = e.target.files;
      if (files.length > 0) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.onload = (e) => {
          this.uploadedImage = e.target.result;
        };
      }
    },
    onFileChangeBack(e) {
      const files = e.target.files;
      if (files.length > 0) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.onload = (e) => {
          this.uploadedImageBack = e.target.result;
        };
      }
    },
	formatTrayName(className) {
		return className
			.replace(/(.)([A-Z])/g, '$1 $2')
			.replace(/\d+/g, '')
			.trim()
			.split(/\s+/)
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	},
	selectSize(event) {
		this.selectedSizeCode = event.target.value;
		let selectedOption = event.target.options[event.target.selectedIndex];
		this.selectedTraySize = selectedOption.text;
	},
	downloadImage() {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
			filter: function (node) {
				return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach') && !node.classList.contains('tray-note');
				}
			})
			.then((dataUrl) => {
				const link = document.createElement('a');
				link.href = dataUrl;
				link.download = 'My-Custom-Cambro-Tray.png';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((error) => {
				console.error('Failed to download image', error);
			});
		},
  emailImage() {
      const trayElement = document.getElementById('tray-container');
      html2canvas(trayElement).then((canvas) => {
        canvas.toBlob((blob) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            const subject = encodeURIComponent('Check out my custom Cambro tray');
            const body = encodeURIComponent(
              `Check out the custom tray I designed: ${base64data}\n\n` +
              `You can design your own here: https://appscambro.com/tray-personalization`
            );
            window.open(`mailto:?subject=${subject}&body=${body}`);
          };
        });
      });
  },
  },
  computed: {
	selectedTrayName() {
    const colorName = this.formatTrayName(this.selectedColor);
    const colorCodeMatch = this.selectedColor.match(/(\d+)$/);
    const colorCode = colorCodeMatch ? colorCodeMatch[1] : '';
    return `${colorName} (${colorCode})`;
  },
	productCode() {
		let colorCodeMatch = this.selectedColor.match(/\d+$/);
		let colorCode = colorCodeMatch ? colorCodeMatch[0] : '';
		return `${this.selectedSizeCode}${colorCode}`;
	}
  },
};
</script>
  
